
define(function (require) {
    "use strict";

    var LE = require("app");
    var RevisionedModel = require("models/RevisionedModel");
    var LEResourceResolver = require("leResourceResolver");

    //list of keys on the Content JSON instead of repeating strings everywhere
    var KEYS = {
        ID: "id",
        NAME: "name",
        ENABLED: "enabled",   //Whether the item is active or not
        DELETED: "deleted",   //Whether the item is deleted or not
        DATA: "data",
        MSG: "msg",
        TITLE: "title",
        LANG: "lang",
        ATTRIBUTES: "attributes",
        ATTR_NAME: "name",
        ATTR_VALUE: "value",
    };
    var ContentSystemMessagingBaseModel = {};
    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentSystemMessagingBaseModel = RevisionedModel.extend({
            langContentIndexMap: {},
            defaults : {
                id: "",
                enabled: true,
                deleted: false,
                data: [],
                attributes: {}
            },

            initialize: function(options){
                RevisionedModel.prototype.initialize.call(this, options);
                this.resetLanguageContentMap();
            },

            publishEnableValidation: {

            },

            validation: {

            },

            /*
             Create a map object to map between language string - and its index on the model language content array
             */
            resetLanguageContentMap: function() {
                var langContentArray = this.getData();
                this.langContentIndexMap = {};
                _.each(langContentArray, function(element, index, list){
                    this.langContentIndexMap[element.lang] = index;
                }, this) ;
            },
            hasContentMessage: function(lang){
                return this.hasLanguage(lang) &&
                    this.getContentMessage(lang).length > 0;
            },

            hasLanguage: function(lang){
                return _.has(this.langContentIndexMap,lang);
            },
            getData: function(){
                return this.get(KEYS.DATA);
            },
            setData: function(data, options){
                options = options || {};
                options.silent = true;

                this.set(KEYS.DATA, data, options);
                this.resetLanguageContentMap();
                this.trigger("change:data change");
            },
            setID: function(id) {
                return this.set(KEYS.ID, id);
            },
            getID: function() {
                return this.get(KEYS.ID);
            },
            getEventId: function (){
                return this.getID();
            },
            getAttrs: function () {
                return this.get(KEYS.ATTRIBUTES);
            },
            setAttrs: function (attr) {
                return this.set(KEYS.ATTRIBUTES,attr);
            },

            getContentMessage: function(lang){
                if (this.hasLanguage(lang)){
                    var msg = this.get(this.getContentMSGKey(lang));
                    return msg? msg:"";
                }  else {
                    return "";
                }
            },

            setContentMessage: function(lang,message){
                if (!this.hasLanguage(lang)){
                    this._addNewContent(lang);
                }
                this.set(this.getContentMSGKey(lang),message);
            },

            _addNewContent: function(lang){
                this.langContentIndexMap[lang ] = this._getIndexForNewContent();
                this.set(this.getContentKey(lang),{msg: "","lang": lang});
            },
            _getIndexForNewContent : function(){
                var data = this.getData();
                //support index 0 and it will be created
                return data ? data.length : 0;
            },
            //return list of all language codes found on the data
            getLanguages: function() {
                var langArray = [];
                var data = this.getData();
                if (data) {
                    langArray = _.map(data,function(obj){
                        return obj[KEYS.LANG];
                    });
                }

                return langArray;
            },
            getEnabledState: function(){
                return this.get(KEYS.ENABLED);
            },
            setEnabledState: function(state){
                this.set(KEYS.ENABLED,state);
            },
            getContentDataKey: function(){
                return KEYS.DATA;
            },
            getContentKey: function(lang){
                return KEYS.DATA+"."+this.langContentIndexMap[lang];
            },
            getContentMSGKey: function(lang){
                return this.getContentKey(lang) +"."+ KEYS.MSG;
            },
            isEnabledEditable: function(){
                return true;
            },
            /**
             * Basic content validation called implicitly by the UI ( not the validate that is called by save )
             * @returns {*}
             */
            validateContent: function() {
                this.setValidations();
                return this.isValidAttr();
            },

            setValidations: function(){

            },
            parse: function(response, options) {

                response[KEYS.ENABLED] = _.has(response,KEYS.ENABLED) ? response[KEYS.ENABLED] : this.defaults[KEYS.ENABLED];

                return RevisionedModel.prototype.parse.call(this, response, options);
            },
            save: function(attributes, options){
                this.cleanData();
                this.setValidations();
                this.logger.info("Saving Content message","ContentSystemMessagingBaseModel:save",this.attributes);
                return RevisionedModel.prototype.save.call(this, attributes, options);
            },
            isValidAttr: function(attributes){
                this.setValidations();
                return RevisionedModel.prototype.isValidAttr.call(this,attributes);
            }
        });
    });

    ContentSystemMessagingBaseModel.KEYS = KEYS;

    return ContentSystemMessagingBaseModel;
});
